/* Options:
Date: 2025-02-17 14:28:58
Version: 6.70
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: http://localhost:5000/api

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
ExcludeTypes: BaseService,Routes,IPrincipal,DTOs,Validators,Dtos,AuthService,PagesServices
//DefaultImports: 
*/


export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IHasSessionId
{
    sessionId: string;
}

export interface IHasBearerToken
{
    bearerToken: string;
}

export interface IPost
{
}

export interface IGet
{
}

export interface IDelete
{
}

export class Coordinate
{
    public lat: number;
    public lng: number;

    public constructor(init?: Partial<Coordinate>) { (Object as any).assign(this, init); }
}

export class Location
{
    public formattedAddress: string;
    public placeId: string;
    public streetNumber: string;
    public route: string;
    public locality: string;
    public administrativeAreaLevel1: string;
    public postalCode: string;
    public country: string;
    public lat: string;
    public lng: string;

    public constructor(init?: Partial<Location>) { (Object as any).assign(this, init); }
}

export class TerritoriesService
{

    public constructor(init?: Partial<TerritoriesService>) { (Object as any).assign(this, init); }
}

export class TalentSearchService
{

    public constructor(init?: Partial<TalentSearchService>) { (Object as any).assign(this, init); }
}

export class RelatedProductsServices
{

    public constructor(init?: Partial<RelatedProductsServices>) { (Object as any).assign(this, init); }
}

export class QuizzesService
{

    public constructor(init?: Partial<QuizzesService>) { (Object as any).assign(this, init); }
}

export class QuestionToGrade
{
    public id: string;
    public selectedAnswers: string[];

    public constructor(init?: Partial<QuestionToGrade>) { (Object as any).assign(this, init); }
}

export class GamificationService
{

    public constructor(init?: Partial<GamificationService>) { (Object as any).assign(this, init); }
}

export class TheatreCompanyDTO
{
    public id: string;
    public intId: string;
    public name: string;
    public slug: string;
    public fanCount: number;
    public location: Location;
    public shortAddressPrettified: string;
    public formattedAddress: string;
    public types: string[];
    public phone: string;
    public url: string;
    public email: string;
    public twitterUsername: string;
    public facebook: string;
    public instagram: string;
    public youtube: string;
    public isNoLongerActive: boolean;
    public logoUrl: string;
    public logoFileName: string;
    public hasLogo: boolean;
    public hasSocialMedia: boolean;
    public hasContacts: boolean;
    public hasLocationPlaceId: boolean;
    public about: string;
    public lastModifiedBy: string;
    public lastModifiedByProfile: string;
    public lastModifiedOn: string;
    public lastModifiedOnFormatted: string;
    public opportunityCount: number;
    public alumniCount: number;
    public properUrl: string;

    public constructor(init?: Partial<TheatreCompanyDTO>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

export class Region
{
    public id: string;
    public name: string;
    public city: string;
    public state: string;
    public country: string;
    public slug: string;
    public lat: string;
    public lng: string;

    public constructor(init?: Partial<Region>) { (Object as any).assign(this, init); }
}

export class Headshot
{
    public id: string;
    public fileName: string;
    public isHeadshot: boolean;

    public constructor(init?: Partial<Headshot>) { (Object as any).assign(this, init); }
}

export class AuthorshipDTO
{
    public id: string;
    public firstName: string;
    public lastName: string;
    public authorship: string;
    public name: string;

    public constructor(init?: Partial<AuthorshipDTO>) { (Object as any).assign(this, init); }
}

export class ShowMetadata
{
    public tags: string[];

    public constructor(init?: Partial<ShowMetadata>) { (Object as any).assign(this, init); }
}

export class ShowDto
{
    public id: string;
    public title: string;
    public urlSlug: string;
    public logo: string;
    public imageCaption: string;
    public englishTitle: string;
    public category: string;
    public genres: string[];
    public firstYearProduced: string;
    public themesMotifs: string;
    public quoteAnalysis: string;
    public plotOverview: string;
    public plotOverviewExcerpt: string;
    public detailedPlot: string;
    public usefulLinks: string;
    public numberOfActs: number;
    public castCount: number;
    public castSize: string;
    public maleCast: number;
    public femaleCast: number;
    public castAgeRanges: string[];
    public fanCount: number;
    public dancingLevel: string;
    public songs: string;
    public basedOnThePlayOrFilm: string;
    public context: string;
    public orchestraSize: string;
    public settings: string[];
    public timePeriods: string;
    public licensorUrl: string;
    public licensor: string;
    public idealFors: string[];
    public tags: string[];
    public itunesEmbedCode: string;
    public youtubeLinks: string[];
    public videoLinks: Tuple<string,string>[];
    public authors: AuthorshipDTO[];
    public creditsTo: { [index: string]: string; };
    public hasSongs: boolean;
    public stageAgentAuthorIdsToCite: string[];
    public citationDetail: string;
    public hasDetailCitation: boolean;
    public opportunityCount: number;
    public contentRating: string;
    public hasScript: boolean;
    public metadata: ShowMetadata;
    public adminMetadataTags: string[];
    public publishedOnUtc?: string;

    public constructor(init?: Partial<ShowDto>) { (Object as any).assign(this, init); }
}

export class GuideTypeWithCount
{
    public guideType: string;
    public totalResults?: number;

    public constructor(init?: Partial<GuideTypeWithCount>) { (Object as any).assign(this, init); }
}

export class SocialLinks
{
    public web: string;
    public fb: string;
    public tw: string;
    public in: string;
    public yt: string;
    public pn: string;
    public tk: string;
    public ln: string;
    public sc: string;
    public allSocialLinksAreEmpty: boolean;

    public constructor(init?: Partial<SocialLinks>) { (Object as any).assign(this, init); }
}

export class CollegeProgramDtoLightWeight
{
    public id: string;
    public programName: string;
    public logoUrlOrDefault: string;
    public slug: string;
    public displayAddress: string;
    public fanCount?: number;
    public alumniCount?: number;

    public constructor(init?: Partial<CollegeProgramDtoLightWeight>) { (Object as any).assign(this, init); }
}

export class CreditDTO
{
    public id: string;
    public type: string;
    public showId: string;
    public showName: string;
    public role: string;
    public organizationId: string;
    public organizationName: string;
    public showUrl: string;
    public organizationUrl: string;

    public constructor(init?: Partial<CreditDTO>) { (Object as any).assign(this, init); }
}

export class VideoReel
{
    public id: string;
    public url: string;
    public provider: string;
    public thumbnailUrl: string;
    public isPrimary: boolean;

    public constructor(init?: Partial<VideoReel>) { (Object as any).assign(this, init); }
}

export class ResumeDTO
{
    public friendlyName: string;
    public url: string;
    public uploadedDate: string;
    public uploadedDateFormatted: string;

    public constructor(init?: Partial<ResumeDTO>) { (Object as any).assign(this, init); }
}

export class TalentSearchProfileDTO
{
    public id: string;
    public profileUrl: string;
    public saUrl: string;
    public fansUrl: string;
    public displayName: string;
    public gender: string;
    public fanCount: number;
    public headShotUrl: string;
    public headShotFileName: string;
    public hasHeadShot: boolean;
    public vocalPart: string;
    public ageRange: string;
    public intro: string;
    public roles: Array<string>;
    public location: Location;
    public shortAddressPrettified: string;

    public constructor(init?: Partial<TalentSearchProfileDTO>) { (Object as any).assign(this, init); }
}

export class StageAgentAuthorDtoLightweight
{
    public id: string;
    public slug: string;
    public name: string;
    public status: string;
    public role: string;
    public sort: number;
    public headshotUrl: string;
    public jobTitle: string;
    public bioExcerpt: string;
    public stageAgentHandle: string;
    public createdAtUtc?: string;
    public updatedAtUtc?: string;
    public isActive: boolean;

    public constructor(init?: Partial<StageAgentAuthorDtoLightweight>) { (Object as any).assign(this, init); }
}

export class LearningModuleDtoLightWeight
{
    public id: string;
    public topic: string;
    public slug: string;
    public imageUrl: string;
    public subtitle1: string;
    public subtitle2: string;
    public keywords: string[];
    public excerpt: string;
    public authors: StageAgentAuthorDtoLightweight[];
    public learningModelCategories: string[];
    public createdAtUtc?: string;
    public updatedAtUtc?: string;
    public lastUpdatedFromContentfulOnUtc: string;

    public constructor(init?: Partial<LearningModuleDtoLightWeight>) { (Object as any).assign(this, init); }
}

export class CategoryWithCount
{
    public category: string;
    public url: string;
    public totalResults?: number;

    public constructor(init?: Partial<CategoryWithCount>) { (Object as any).assign(this, init); }
}

export class RelatedProductFromAmazonDto
{
    public asin: string;
    public title: string;
    public itemUrl: string;
    public coverUrl: string;
    public instruments: string;
    public format: string;
    public productGroup: string;
    public price: string;
    public searchUrl: string;

    public constructor(init?: Partial<RelatedProductFromAmazonDto>) { (Object as any).assign(this, init); }
}

export class HeadshotDto
{
    public id: string;
    public fileName: string;
    public isHeadshot: boolean;

    public constructor(init?: Partial<HeadshotDto>) { (Object as any).assign(this, init); }
}

export class UploadedResumeDTO
{
    public id: string;
    public friendlyName: string;
    public fileName: string;
    public url: string;
    public uploadedDate: string;
    public uploadedDateFormatted: string;
    public isFeatured: boolean;

    public constructor(init?: Partial<UploadedResumeDTO>) { (Object as any).assign(this, init); }
}

export class ExperienceDTO
{
    public id: string;
    public type: string;
    public dateYear: string;
    public showName: string;
    public role: string;
    public organizationId: string;
    public organizationName: string;
    public director: string;
    public isFeatured: boolean;

    public constructor(init?: Partial<ExperienceDTO>) { (Object as any).assign(this, init); }
}

export class VideoReelDTO
{
    public id: string;
    public url: string;
    public provider: string;
    public thumbnailUrl: string;
    public isPrimary: boolean;

    public constructor(init?: Partial<VideoReelDTO>) { (Object as any).assign(this, init); }
}

export class OpportunityDTOLightweight
{
    public id: string;
    public intId: string;
    public title: string;
    public slug: string;
    public category: string;
    public type: string;
    public imageUrl: string;
    public startDate: string;
    public endDate: string;
    public endDateInPstAsString: string;
    public compensation: string;
    public address: string;
    public payment: string;
    public regionName: string;
    public regionId: string;
    public auditionOrInterviewFormat: string;
    public postedByMemberId: string;
    public isPostedByProMember: boolean;
    public createdAtUtc: string;
    public updatedAtUtc: string;
    public canBeUnlocked: boolean;
    public isLocked: boolean;
    public lockedOn?: string;
    public unlockedOn?: string;
    public unlockedUntil?: string;
    public unlockedUntilInPstAsString: string;
    public isVisible: boolean;
    public visibleOn?: string;
    public invisibleOn?: string;
    public isArchived: boolean;
    public archivedOn?: string;

    public constructor(init?: Partial<OpportunityDTOLightweight>) { (Object as any).assign(this, init); }
}

export class OpportunityDTO
{
    public id: string;
    public intId: string;
    public category: string;
    public type: string;
    public title: string;
    public slug: string;
    public companyId: string;
    public companyName: string;
    public regionId: string;
    public regionName: string;
    public auditionOrInterviewFormat: string;
    public startDate: string;
    public endDate: string;
    public endDateInPstAsString: string;
    public description: string;
    public webUrl: string;
    public email: string;
    public phone: string;
    public imageUrl: string;
    public compensation: string;
    public address: string;
    public union: string;
    public relatedGuideId: string;
    public postedByMemberId: string;
    public postedByMemberProfileUrl: string;
    public postedByMemberName: string;
    public isPostedByProMember: boolean;
    public createdAtUtc: string;
    public updatedAtUtc: string;
    public canBeUnlocked: boolean;
    public isLocked: boolean;
    public lockedOn?: string;
    public unlockedOn?: string;
    public unlockedUntil?: string;
    public unlockedUntilInPstAsString: string;
    public isVisible: boolean;
    public visibleOn?: string;
    public invisibleOn?: string;
    public isArchived: boolean;
    public archivedOn?: string;
    public datesAsString: string;

    public constructor(init?: Partial<OpportunityDTO>) { (Object as any).assign(this, init); }
}

export class SubscriptionDTO
{
    public id: string;
    public name: string;
    public status: string;
    public canceledAt: string;
    public endedAt: string;
    public currentPeriodEnd?: string;
    public cancelAtPeriodEnd: boolean;
    public canGoToSubscriptions: Array<string>;
    public currentPeriodEndFormatted: string;
    public currentPeriodEndAsTimestamp?: number;
    public priceAsString: string;
    public planPriceInWords: string;

    public constructor(init?: Partial<SubscriptionDTO>) { (Object as any).assign(this, init); }
}

export class CardDTO
{
    public name: string;
    public last4: string;
    public brand: string;
    public expMonth: number;
    public expYear: number;

    public constructor(init?: Partial<CardDTO>) { (Object as any).assign(this, init); }
}

export class CharacterDto
{
    public id: string;
    public name: string;
    public fanCount: number;
    public description: string;
    public gender: string;
    public ageRanges: Array<string>;
    public vocalParts: Array<string>;
    public roleSize: string;
    public roleSizeValue: string;
    public dancingLevel: string;
    public timePeriods: string;
    public highNote: string;
    public lowNote: string;
    public vocalTechniques: Array<string>;
    public tags: Array<string>;
    public youtubeLinks: Array<string>;
    public youtubeLinksScrubbed: Array<string>;
    public videoLinks: Tuple<string,string>[];
    public showId: string;
    public showTitle: string;
    public showCategory: string;
    public showLogo: string;
    public showImageCaption: string;
    public authors: Array<AuthorDto>;
    public contentRating: string;
    public urlSlug: string;

    public constructor(init?: Partial<CharacterDto>) { (Object as any).assign(this, init); }
}

export class AuditionSongDto
{
    public id: string;
    public title: string;
    public showCategory: string;
    public showTitle: string;
    public showId: string;
    public showLogo: string;
    public showImageCaption: string;
    public fanCount: number;
    public authors: AuthorDto[];
    public characters: CharacterDto[];
    public characterName: string;
    public characterId: string;
    public characterGender: string;
    public characterAgeRanges: string[];
    public lowNote: string;
    public highNote: string;
    public vocalParts: string[];
    public styles: string[];
    public vocalNotes: string;
    public cutSuggestions: string;
    public context: string;
    public lyrics: string;
    public usefulLinks: string;
    public contentRating: string;
    public itunesEmbedCode: string;
    public tags: string[];
    public youtubePerformanceLinks: string[];
    public youtubeKaraokeLinks: string[];
    public youtubePerformanceLinksScrubbed: string[];
    public youtubeKaraokeLinksScrubbed: string[];
    public performanceVideoLinks: Tuple<string,string>[];
    public karaokeVideoLinks: Tuple<string,string>[];
    public urlSlug: string;

    public constructor(init?: Partial<AuditionSongDto>) { (Object as any).assign(this, init); }
}

export class CharacterFromASceneDto
{
    public id: string;
    public name: string;

    public constructor(init?: Partial<CharacterFromASceneDto>) { (Object as any).assign(this, init); }
}

export class SceneDto
{
    public id: string;
    public title: string;
    public showCategory: string;
    public showTitle: string;
    public showId: string;
    public showLogo: string;
    public showImageCaption: string;
    public fanCount: number;
    public authors: Array<AuthorDto>;
    public characters: Array<CharacterFromASceneDto>;
    public length: string;
    public period: string;
    public style: string;
    public timeAndPlace: string;
    public citation: string;
    public content: string;
    public contentClean: string;
    public excerpt: string;
    public usefulLinks: string;
    public displaysFullText: boolean;
    public context: string;
    public contentRating: string;
    public youtubeLinks: Array<string>;
    public tags: Array<string>;
    public hasVideos: boolean;
    public videoLinks: Tuple<string,string>[];
    public numOfMaleCharacters: number;
    public numOfFemaleCharacters: number;
    public characterAgeRanges: Array<string>;
    public getExcerptOrDefault: string;
    public urlSlug: string;

    public constructor(init?: Partial<SceneDto>) { (Object as any).assign(this, init); }
}

export class AuthorDto
{
    public id: string;
    public name: string;
    public gender: string;
    public image: string;
    public imageUrl: string;
    public imageCaption: string;
    public fanCount: number;
    public jobTitles: Array<string>;
    public nationality: string;
    public biography: string;
    public bornOn?: string;
    public diedOn?: string;
    public tags: Array<string>;
    public usefulLinks: string;
    public shows: Array<ShowDto>;
    public monologues: Array<MonologueDto>;
    public songs: Array<AuditionSongDto>;
    public scenes: Array<SceneDto>;
    public youtubeLinks: Array<string>;
    public categories: Array<string>;
    public genres: Array<string>;
    public settings: Array<string>;
    public timePeriods: Array<string>;
    public youtubeLinksScrubbed: Array<string>;
    public videoLinks: Tuple<string,string>[];
    public bornOnFormatted: string;
    public diedOnFormatted: string;
    public hasImage: boolean;
    public knownForShows: ShowDto[];
    public shouldBeCreditedForMonologues: boolean;
    public shouldBeCreditedForSongs: boolean;
    public urlSlug: string;

    public constructor(init?: Partial<AuthorDto>) { (Object as any).assign(this, init); }
}

export class MonologueDto
{
    public id: string;
    public showCategory: string;
    public showTitle: string;
    public showId: string;
    public showLogo: string;
    public showImageCaption: string;
    public urlSlug: string;
    public authors: Array<AuthorDto>;
    public fanCount: number;
    public characterName: string;
    public characterId: string;
    public characterGender: string;
    public characterAgeRanges: Array<string>;
    public duration: string;
    public period: string;
    public style: string;
    public content: string;
    public contentClean: string;
    public displaysFullText: boolean;
    public excerpt: string;
    public context: string;
    public act: string;
    public setting: string;
    public usefulLinks: string;
    public tags: Array<string>;
    public youtubeLinks: Array<string>;
    public hasVideos: boolean;
    public videoLinks: Tuple<string,string>[];
    public isInHouseContent: boolean;
    public contentRating: string;
    public getExcerptOrDefault: string;

    public constructor(init?: Partial<MonologueDto>) { (Object as any).assign(this, init); }
}

export class BadgeDTO
{
    public id: string;
    public name: string;
    public imageUrl: string;
    public points: number;

    public constructor(init?: Partial<BadgeDTO>) { (Object as any).assign(this, init); }
}

export class LeaderboardEntry
{
    public rank: number;
    public memberId: string;
    public displayName: string;
    public profileUrl: string;
    public profileDeleted: boolean;
    public imageUrl: string;
    public shortAddressPrettified: string;
    public points: number;

    public constructor(init?: Partial<LeaderboardEntry>) { (Object as any).assign(this, init); }
}

export class LeaderboardDto
{
    public entries: LeaderboardEntry[];
    public for: string;
    public lastUpdatedDateInUtc: string;

    public constructor(init?: Partial<LeaderboardDto>) { (Object as any).assign(this, init); }
}

export class YourBookmarkDto
{
    public imageUrl: string;
    public title: string;
    public subtitle: string;
    public type: string;
    public targetId: string;
    public targetUrl: string;
    public bookmarkedOnUtc: string;

    public constructor(init?: Partial<YourBookmarkDto>) { (Object as any).assign(this, init); }
}

export class BlogPostDtoLightweight
{
    public id: string;
    public slug: string;
    public title: string;
    public excerpt: string;
    public featuredImageUrl: string;
    public categories: string[];
    public tags: string[];
    public authors: StageAgentAuthorDtoLightweight[];
    public publishedOn?: string;
    public createdAtUtc?: string;
    public updatedAtUtc?: string;
    public lastUpdatedFromContentfulOnUtc: string;
    public idWithoutPrefix: string;
    public publishedOnAsString: string;
    public updatedAtUtcAsString: string;

    public constructor(init?: Partial<BlogPostDtoLightweight>) { (Object as any).assign(this, init); }
}

export class AuditionDTO
{
    public id: string;
    public urlSlug: string;
    public showTitle: string;
    public showLogoFileName: string;
    public showLogoUrl: string;
    public compensation: string;
    public union: string;
    public organizationName: string;
    public organizationId: string;
    public organizationUrl: string;
    public appointmentRequired: boolean;
    public venue: Location;
    public description: string;
    public whatToPrepare: string;
    public characterBreakdowns: string;
    public enquiryPhone: string;
    public enquiryEmail: string;
    public webUrl: string;
    public createdBy: string;
    public lastModifiedBy: string;
    public lastModifiedByProfile: string;
    public lastModifiedOn: string;
    public lastModifiedOnFormatted: string;
    public shortAddressPrettified: string;
    public categories: string[];
    public keywords: string[];
    public isFeatured: boolean;

    public constructor(init?: Partial<AuditionDTO>) { (Object as any).assign(this, init); }
}

export class ProfileHeadshotsSettings
{

    public constructor(init?: Partial<ProfileHeadshotsSettings>) { (Object as any).assign(this, init); }
}

export class ProfileResumeSettingsEndpoint
{

    public constructor(init?: Partial<ProfileResumeSettingsEndpoint>) { (Object as any).assign(this, init); }
}

export class ProfileVideosService
{

    public constructor(init?: Partial<ProfileVideosService>) { (Object as any).assign(this, init); }
}

export class ProfileActionsService
{

    public constructor(init?: Partial<ProfileActionsService>) { (Object as any).assign(this, init); }
}

export class ShowsDtos
{

    public constructor(init?: Partial<ShowsDtos>) { (Object as any).assign(this, init); }
}

export class Tuple<T1, T2>
{
    public item1: T1;
    public item2: T2;

    public constructor(init?: Partial<Tuple<T1, T2>>) { (Object as any).assign(this, init); }
}

export class WritersDtos
{

    public constructor(init?: Partial<WritersDtos>) { (Object as any).assign(this, init); }
}

export class AuditionSongsDtos
{

    public constructor(init?: Partial<AuditionSongsDtos>) { (Object as any).assign(this, init); }
}

export class ScenesDtos
{

    public constructor(init?: Partial<ScenesDtos>) { (Object as any).assign(this, init); }
}

export class MonologuesDtos
{

    public constructor(init?: Partial<MonologuesDtos>) { (Object as any).assign(this, init); }
}

export class CharactersDtos
{

    public constructor(init?: Partial<CharactersDtos>) { (Object as any).assign(this, init); }
}

export class BlogPostsDtos
{

    public constructor(init?: Partial<BlogPostsDtos>) { (Object as any).assign(this, init); }
}

export interface IHasId
{
    id: string;
}

export interface IHasMetadata
{
    metadata: { [index: string]: string; };
}

export interface IHasObject
{
    object: string;
}

// @DataContract
export class ResponseStatus
{
    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class SearchCompaniesByFiltersResponse extends ResponseStatus
{
    public results: TheatreCompanyDTO[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchCompaniesByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetTalentContributedGuidesResponse
{
    public id: string;
    public isPro: boolean;
    public isProfileVisible: boolean;
    public profileInvisibleReason: string;
    public saUrl: string;
    public profileUrl: string;
    public displayName: string;
    public gender: string;
    public headShotUrl: string;
    public headShotFileName: string;
    public allRoles: string[];
    public hasHeadShot: boolean;
    public location: Location;
    public shortAddressPrettified: string;
    public headshots: Headshot[];
    public contributedGuides: ShowDto[];

    public constructor(init?: Partial<GetTalentContributedGuidesResponse>) { (Object as any).assign(this, init); }
}

export class GetTalentFavoritesResponse extends ResponseStatus
{
    public id: string;
    public profileUrl: string;
    public guideType: string;
    public results: Object;
    public totalResults: number;
    public currentPage: number;
    public pageSize: number;
    public guideTypesWithCounts: GuideTypeWithCount[];

    public constructor(init?: Partial<GetTalentFavoritesResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetTalentProfileResponse extends ResponseStatus
{
    public id: string;
    public isPro: boolean;
    public isMessagingEnabled: boolean;
    public isChild: boolean;
    public isProfileVisible: boolean;
    public profileInvisibleReason: string;
    public saUrl: string;
    public profileUrl: string;
    public displayName: string;
    public gender: string;
    public headShotUrl: string;
    public headShotFileName: string;
    public allRoles: string[];
    public createdDate: string;
    public hasHeadShot: boolean;
    public location: Location;
    public shortAddressPrettified: string;
    public createdDatePrettyDate: string;
    public isContributor: boolean;
    public vocalPart: string;
    public vocalRange: string;
    public isNonSinger: boolean;
    public intro: string;
    public dancingLevel: string;
    public educationOrTraining: string;
    public specialSkills: string;
    public ageRange: string;
    public heightAsString: string;
    public bodyType: string;
    public eyes: string;
    public hair: string;
    public ethnicity: Array<string>;
    public social: SocialLinks;
    public representedBy: string;
    public representationLocation: string;
    public representationWebsite: string;
    public isUnionMember: boolean;
    public affiliations: string[];
    public unionAffiliations: string;
    public fanCount?: number;
    public headshots: Headshot[];
    public similarTalents: TalentSearchProfileDTO[];
    public fannedCollegePrograms: CollegeProgramDtoLightWeight[];
    public credits: CreditDTO[];
    public videoReels: VideoReel[];
    public resumes: ResumeDTO[];

    public constructor(init?: Partial<GetTalentProfileResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetTalentsResponse extends ResponseStatus
{
    public results: TalentSearchProfileDTO[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<GetTalentsResponse>) { super(init); (Object as any).assign(this, init); }
}

export class CreateAccountResponse
{
    public redirectToUrl: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateAccountResponse>) { (Object as any).assign(this, init); }
}

export class SignupNewUserResponse
{
    public redirectUrl: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SignupNewUserResponse>) { (Object as any).assign(this, init); }
}

export class SearchGuidesUsingAutocompleteResponse
{
    public shows: ShowDto[];
    public learningModules: LearningModuleDtoLightWeight[];
    public categoriesWithCounts: CategoryWithCount[];
    public relatedTags: string[];
    public suggestions: string[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SearchGuidesUsingAutocompleteResponse>) { (Object as any).assign(this, init); }
}

export class SearchGuidesByCategoryResponse
{
    public results: Object;
    public totalResults: number;
    public currentPage: number;
    public pageSize: number;
    public categoriesWithCounts: CategoryWithCount[];
    public relatedTags: string[];
    public suggestions: string[];
    public category: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SearchGuidesByCategoryResponse>) { (Object as any).assign(this, init); }
}

export class GradeQuizResponse
{
    public quizId: string;
    public score: string;
    public hasCompletedInThePast: boolean;
    public correctResponses: string[];
    public inCorrectResponses: string[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GradeQuizResponse>) { (Object as any).assign(this, init); }
}

export class GetProfileCustomUrlResponse
{
    public currentProfileUrl: string;
    public hasCustomUrl: boolean;

    public constructor(init?: Partial<GetProfileCustomUrlResponse>) { (Object as any).assign(this, init); }
}

export class GetProfileHeadshotsResponse
{
    public headshots: HeadshotDto[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetProfileHeadshotsResponse>) { (Object as any).assign(this, init); }
}

export class GetProfileOutsideLinksResponse
{
    public web: string;
    public fb: string;
    public tw: string;
    public in: string;
    public yt: string;
    public pn: string;
    public tk: string;
    public ln: string;
    public sc: string;

    public constructor(init?: Partial<GetProfileOutsideLinksResponse>) { (Object as any).assign(this, init); }
}

export class GetProfileRegionResponse extends ResponseStatus
{
    public closestRegionForUser: Region;

    public constructor(init?: Partial<GetProfileRegionResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetProfileRepresentationResponse
{
    public representedBy: string;
    public representationLocation: string;
    public representationWebsite: string;
    public unionAffiliations: string[];
    public unionAffiliationsOptions: string[];

    public constructor(init?: Partial<GetProfileRepresentationResponse>) { (Object as any).assign(this, init); }
}

export class GetResumesResponse
{
    public resumes: UploadedResumeDTO[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetResumesResponse>) { (Object as any).assign(this, init); }
}

export class GetExperiencesResponse
{
    public credits: ExperienceDTO[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetExperiencesResponse>) { (Object as any).assign(this, init); }
}

export class GetProfileSettingBasicsResponse extends ResponseStatus
{
    public accountName: string;
    public profileDisplayName: string;
    public performerRolesOptions: string[];
    public staffRolesOptions: string[];
    public teacherRolesOptions: string[];
    public performerRoles: string[];
    public staffRoles: string[];
    public teacherRoles: string[];
    public intro: string;

    public constructor(init?: Partial<GetProfileSettingBasicsResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetProfileSettingSkillsResponse extends ResponseStatus
{
    public vocalPart: string;
    public vocalRangeMin: string;
    public vocalRangeMax: string;
    public dancingLevel: string;
    public educationOrTraining: string;
    public specialSkills: string;
    public vocalPartOptions: string[];
    public dancingLevelOptions: string[];
    public vocalRangeOptions: string[];

    public constructor(init?: Partial<GetProfileSettingSkillsResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetProfileAppearanceResponse
{
    public gender: string;
    public heightFeet: string;
    public heightInches: string;
    public ageRange: string;
    public eyes: string;
    public hair: string;
    public bodyType: string;
    public ethnicity: string[];
    public genderOptions: string[];
    public ageRangeOptions: string[];
    public hairOptions: string[];
    public eyesOptions: string[];
    public bodyTypeOptions: string[];
    public ethnicityOptions: string[];

    public constructor(init?: Partial<GetProfileAppearanceResponse>) { (Object as any).assign(this, init); }
}

export class GetVideoReelsResponse extends ResponseStatus
{
    public reels: VideoReelDTO[];

    public constructor(init?: Partial<GetVideoReelsResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetProfileVisibilityResponse
{
    public visibleTo: string;

    public constructor(init?: Partial<GetProfileVisibilityResponse>) { (Object as any).assign(this, init); }
}

export class UserMetadata
{
    public id: string;
    public userId: string;
    public tags: string[];

    public constructor(init?: Partial<UserMetadata>) { (Object as any).assign(this, init); }
}

export class GetOpportunitiesNearMeResponse extends ResponseStatus
{
    public locationFormattedAddress: string;
    public results: OpportunityDTOLightweight[];

    public constructor(init?: Partial<GetOpportunitiesNearMeResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetRecentOpportunitiesForWidgetResponse extends ResponseStatus
{
    public results: OpportunityDTOLightweight[];

    public constructor(init?: Partial<GetRecentOpportunitiesForWidgetResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetOpportunitiesPostedByMeResponse
{
    public results: OpportunityDTOLightweight[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<GetOpportunitiesPostedByMeResponse>) { (Object as any).assign(this, init); }
}

export class GetOpportunityPostedByMeResponse extends ResponseStatus
{
    public opportunity: OpportunityDTO;
    public selectedCompanyName: string;
    public selectedCompanyId: string;
    public selectedShowTitle: string;
    public selectedShowId: string;
    public selectedCompany: TheatreCompanyDTO;
    public selectedShow: ShowDto;

    public constructor(init?: Partial<GetOpportunityPostedByMeResponse>) { super(init); (Object as any).assign(this, init); }
}

export class PostAnOpportunityResponse
{
    public id: string;
    public isPublished: boolean;
    public wasPreview: boolean;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostAnOpportunityResponse>) { (Object as any).assign(this, init); }
}

export class SearchOpportunitiesByFiltersResponse extends ResponseStatus
{
    public results: OpportunityDTOLightweight[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchOpportunitiesByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetBasicProfileInfoForOnboardingResponse extends ResponseStatus
{
    public displayName: string;
    public gender: string;
    public ageRange: string;
    public vocalPart: string;
    public genderOptions: string[];
    public ageRangeOptions: string[];
    public vocalPartOptions: string[];

    public constructor(init?: Partial<GetBasicProfileInfoForOnboardingResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetGoalsForOnboardingResponse extends ResponseStatus
{
    public theatreRolesOptions: string[];
    public theatreRoles: string[];
    public performerRolesOptions: string[];
    public staffRolesOptions: string[];
    public teacherRolesOptions: string[];
    public performerRoles: string[];
    public staffRoles: string[];
    public teacherRoles: string[];

    public constructor(init?: Partial<GetGoalsForOnboardingResponse>) { super(init); (Object as any).assign(this, init); }
}

export class PublishDraftedOpportunityResponse
{
    public id: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PublishDraftedOpportunityResponse>) { (Object as any).assign(this, init); }
}

export class GetProfileMessagingResponse
{
    public isMessagingEnabled: boolean;

    public constructor(init?: Partial<GetProfileMessagingResponse>) { (Object as any).assign(this, init); }
}

export class PreviewChangeMembershipPlanResponse
{
    public amountBilledToday: number;
    public amountCreditedFromCurrentPlan: number;
    public currentRecurringAmount?: number;
    public newRecurringAmount?: number;
    public newPaymentDateInUtc: string;
    public newPaymentDateInPstAsString: string;
    public discountAmount?: number;
    public invoice: Object;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PreviewChangeMembershipPlanResponse>) { (Object as any).assign(this, init); }
}

export class GetMembershipSummaryResponse
{
    public stripeCustomerId: string;
    public subscription: SubscriptionDTO;
    public hasActiveSubscription: boolean;
    public source: CardDTO;
    public hasSource: boolean;

    public constructor(init?: Partial<GetMembershipSummaryResponse>) { (Object as any).assign(this, init); }
}

export class UpgradeToProResponse extends ResponseStatus
{
    public checkoutUrl: string;
    public clientSecret: string;

    public constructor(init?: Partial<UpgradeToProResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetContentForCommunityLandingPageResponse extends ResponseStatus
{
    public locationFormattedAddress: string;
    public auditions: OpportunityDTOLightweight[];
    public classes: OpportunityDTOLightweight[];
    public performances: OpportunityDTOLightweight[];
    public theatreCompanies: TheatreCompanyDTO[];
    public collegePrograms: CollegeProgramDtoLightWeight[];
    public talentProfiles: TalentSearchProfileDTO[];

    public constructor(init?: Partial<GetContentForCommunityLandingPageResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetPopularGuidesResponse extends ResponseStatus
{
    public shows: ShowDto[];

    public constructor(init?: Partial<GetPopularGuidesResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetNewestGuidesResponse extends ResponseStatus
{
    public results: Object;

    public constructor(init?: Partial<GetNewestGuidesResponse>) { super(init); (Object as any).assign(this, init); }
}

export class SearchWritersByFiltersResponse extends ResponseStatus
{
    public results: AuthorDto[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchWritersByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class SearchSongsByFiltersResponse extends ResponseStatus
{
    public results: AuditionSongDto[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchSongsByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class SearchShowsByFiltersResponse extends ResponseStatus
{
    public results: ShowDto[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchShowsByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetRecentShowGuidesResponse extends ResponseStatus
{
    public results: ShowDto[];

    public constructor(init?: Partial<GetRecentShowGuidesResponse>) { super(init); (Object as any).assign(this, init); }
}

export class SearchScenesByFiltersResponse extends ResponseStatus
{
    public results: SceneDto[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchScenesByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class SearchMonologuesByFiltersResponse extends ResponseStatus
{
    public results: MonologueDto[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchMonologuesByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class SearchCharactersByFiltersResponse extends ResponseStatus
{
    public results: CharacterDto[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchCharactersByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetMyGamificationProfileResponse
{
    public runningPointsTally: number;
    public pointsUntilNextBadge: number;
    public currentBadge: BadgeDTO;
    public achievedBadgeCount: number;

    public constructor(init?: Partial<GetMyGamificationProfileResponse>) { (Object as any).assign(this, init); }
}

export class GetLeaderboardStatsResponse
{
    public currentTop5: LeaderboardDto;
    public allTimeTop5: LeaderboardDto;

    public constructor(init?: Partial<GetLeaderboardStatsResponse>) { (Object as any).assign(this, init); }
}

export class SearchCollegeProgramsByFiltersResponse extends ResponseStatus
{
    public results: CollegeProgramDtoLightWeight[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchCollegeProgramsByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetBookmarksResponse
{
    public bookmarks: YourBookmarkDto[];

    public constructor(init?: Partial<GetBookmarksResponse>) { (Object as any).assign(this, init); }
}

export class AddBookmarkResponse
{
    public id: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AddBookmarkResponse>) { (Object as any).assign(this, init); }
}

export class DeleteBookmarkResponse
{
    public id: string;

    public constructor(init?: Partial<DeleteBookmarkResponse>) { (Object as any).assign(this, init); }
}

export class GetRecentPostsForWidgetResponse extends ResponseStatus
{
    public results: BlogPostDtoLightweight[];

    public constructor(init?: Partial<GetRecentPostsForWidgetResponse>) { super(init); (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public profileUrl: string;

    // @DataMember(Order=9)
    public roles: string[];

    // @DataMember(Order=10)
    public permissions: string[];

    // @DataMember(Order=11)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=12)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

export class SignInResponse extends AuthenticateResponse
{

    public constructor(init?: Partial<SignInResponse>) { super(init); (Object as any).assign(this, init); }
}

export class ForgotPasswordResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ForgotPasswordResponse>) { (Object as any).assign(this, init); }
}

export class ResetPasswordResponse
{
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ResetPasswordResponse>) { (Object as any).assign(this, init); }
}

export class SearchTheatreAuditionsByFiltersResponse extends ResponseStatus
{
    public results: AuditionDTO[];
    public currentPage: number;
    public pageSize: number;
    public totalResults: number;

    public constructor(init?: Partial<SearchTheatreAuditionsByFiltersResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetAccountEmailNotificationsSettingsResponse
{
    public emailNotifications: string[];
    public opportunityEmailDigestPreference: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAccountEmailNotificationsSettingsResponse>) { (Object as any).assign(this, init); }
}

export class GetAccountManagerSettingsResponse extends ResponseStatus
{
    public firstName: string;
    public lastName: string;

    public constructor(init?: Partial<GetAccountManagerSettingsResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetSubscriptionPreferencesResponse extends ResponseStatus
{
    public preferences: Object;

    public constructor(init?: Partial<GetSubscriptionPreferencesResponse>) { super(init); (Object as any).assign(this, init); }
}

// @Route("/webhooks/incoming/cio/reengagement_unsuccessful", "POST")
export class ReEngagementUnsuccessfulEvent implements IPost
{
    public id: string;
    public cioId: string;
    public email: string;
    public timestamp: number;

    public constructor(init?: Partial<ReEngagementUnsuccessfulEvent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReEngagementUnsuccessfulEvent'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/webhooks/incoming/stripe", "POST")
export class IncomingStripeWebhook implements IPost
{

    public constructor(init?: Partial<IncomingStripeWebhook>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'IncomingStripeWebhook'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/theatre-companies/search-by-filter", "GET")
export class SearchCompaniesByFiltersRequest implements IReturn<SearchCompaniesByFiltersResponse>
{
    public name: string;
    public lat: string;
    public lng: string;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;
    public sort: string;

    public constructor(init?: Partial<SearchCompaniesByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchCompaniesByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchCompaniesByFiltersResponse(); }
}

// @Route("/theatre-companies/submit", "POST")
export class SubmitCompany implements IReturn<ResponseStatus>, IPost
{
    public name: string;
    public location: Location;
    public webUrl: string;
    public email: string;
    public phone: string;
    public twitter: string;
    public facebook: string;
    public instagram: string;
    public youtube: string;
    public about: string;
    public keywords: string[];
    public image: string;

    public constructor(init?: Partial<SubmitCompany>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitCompany'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/territories", "GET")
export class GetAllTerritories implements IReturn<Region[]>, IGet
{

    public constructor(init?: Partial<GetAllTerritories>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAllTerritories'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Region>(); }
}

// @Route("/talent/{url}/contributed-guides", "GET")
export class GetTalentContributedGuides implements IReturn<GetTalentContributedGuidesResponse>, IGet
{
    public url: string;

    public constructor(init?: Partial<GetTalentContributedGuides>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTalentContributedGuides'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTalentContributedGuidesResponse(); }
}

// @Route("/talent/{url}/favorites", "GET")
export class GetTalentFavorites implements IReturn<GetTalentFavoritesResponse>, IGet
{
    public url: string;
    public guideType: string;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;

    public constructor(init?: Partial<GetTalentFavorites>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTalentFavorites'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTalentFavoritesResponse(); }
}

// @Route("/talent/{url}", "GET")
export class GetTalentProfile implements IReturn<GetTalentProfileResponse>, IGet
{
    public url: string;

    public constructor(init?: Partial<GetTalentProfile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTalentProfile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTalentProfileResponse(); }
}

export class GetSimilarTalents
{
    public excludeProfileIds: string[];
    public gender: string;
    public vocalPart: string;
    public ageRange: string;
    public lat: string;
    public lng: string;

    public constructor(init?: Partial<GetSimilarTalents>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSimilarTalents'; }
    public getMethod() { return 'GET'; }
    public createResponse() {}
}

// @Route("/search/talent", "POST")
export class GetTalents implements IReturn<GetTalentsResponse>
{
    public genders: string[];
    public ageRanges: string[];
    public occupations: string[];
    public vocalParts: string[];
    public danceStyles: string[];
    public ethnicities: string[];
    public name: string;
    public lat: string;
    public lng: string;
    public availableAssets: string[];
    public withPhoto: boolean;
    public withVideo: boolean;
    public unionStatuses: string[];
    public currentPage: number;
    public pageSize: number;

    public constructor(init?: Partial<GetTalents>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTalents'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetTalentsResponse(); }
}

// @Route("/search/alumni", "GET")
export class GetAlumni implements IReturn<GetTalentsResponse>
{
    public companyId: string;

    public constructor(init?: Partial<GetAlumni>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAlumni'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTalentsResponse(); }
}

// @Route("/signup/create-account", "POST")
export class CreateAccount implements IReturn<CreateAccountResponse>, IPost
{
    public id: string;
    public name: string;
    public password: string;
    public agreeToNewsletters: boolean;
    public accountIsForChild: boolean;
    public childDisplayName: string;
    public agreeToAllChildAccountConsents: boolean;

    public constructor(init?: Partial<CreateAccount>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateAccount'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateAccountResponse(); }
}

// @Route("/signup", "POST")
export class SignupNewUser implements IReturn<SignupNewUserResponse>, IPost
{
    public email: string;
    public dob: string;
    public agreeToTerms: boolean;
    public gRecaptchaResponse: string;

    public constructor(init?: Partial<SignupNewUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SignupNewUser'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SignupNewUserResponse(); }
}

// @Route("/search/guides/autocomplete", "GET")
export class SearchGuidesUsingAutocomplete implements IReturn<SearchGuidesUsingAutocompleteResponse>, IGet
{
    public q: string;

    public constructor(init?: Partial<SearchGuidesUsingAutocomplete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchGuidesUsingAutocomplete'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchGuidesUsingAutocompleteResponse(); }
}

// @Route("/search/guides/by-category", "GET")
export class SearchGuidesByCategory implements IReturn<SearchGuidesByCategoryResponse>, IGet
{
    public q: string;
    public category: string;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;

    public constructor(init?: Partial<SearchGuidesByCategory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchGuidesByCategory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchGuidesByCategoryResponse(); }
}

// @Route("/related-products/amazon")
export class GetRelatedProductsFromAmazon implements IReturn<RelatedProductFromAmazonDto[]>
{
    public title: string;

    public constructor(init?: Partial<GetRelatedProductsFromAmazon>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRelatedProductsFromAmazon'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<RelatedProductFromAmazonDto>(); }
}

// @Route("/quizzes/grade")
export class GradeQuiz implements IReturn<GradeQuizResponse>, IPost
{
    public quizId: string;
    public questions: QuestionToGrade[];

    public constructor(init?: Partial<GradeQuiz>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GradeQuiz'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GradeQuizResponse(); }
}

// @Route("/profile-settings/custom-url", "GET")
export class GetProfileCustomUrl implements IReturn<GetProfileCustomUrlResponse>, IGet
{

    public constructor(init?: Partial<GetProfileCustomUrl>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileCustomUrl'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileCustomUrlResponse(); }
}

// @Route("/profile-settings/update-custom-url", "POST")
export class UpdateProfileCustomUrl implements IReturn<ResponseStatus>, IPost
{
    public newUrl: string;

    public constructor(init?: Partial<UpdateProfileCustomUrl>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileCustomUrl'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/headshots", "GET")
export class GetProfileHeadshots implements IReturn<GetProfileHeadshotsResponse>, IGet
{

    public constructor(init?: Partial<GetProfileHeadshots>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileHeadshots'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileHeadshotsResponse(); }
}

// @Route("/profile-settings/headshots/add", "POST")
export class AddProfileHeadshot implements IReturn<GetProfileHeadshotsResponse>, IPost
{
    public fileUrl: string;

    public constructor(init?: Partial<AddProfileHeadshot>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddProfileHeadshot'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetProfileHeadshotsResponse(); }
}

// @Route("/profile-settings/headshots/remove", "DELETE")
export class RemoveProfileHeadshotRequest implements IReturn<GetProfileHeadshotsResponse>, IDelete
{
    public photoId: string;

    public constructor(init?: Partial<RemoveProfileHeadshotRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveProfileHeadshotRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GetProfileHeadshotsResponse(); }
}

// @Route("/profile-settings/headshots/make-headshot", "POST")
export class MakeProfileHeadshotPrimaryRequest implements IReturn<GetProfileHeadshotsResponse>, IPost
{
    public photoId: string;

    public constructor(init?: Partial<MakeProfileHeadshotPrimaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeProfileHeadshotPrimaryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetProfileHeadshotsResponse(); }
}

// @Route("/profile-settings/outside-links", "GET")
export class GetProfileOutsideLinks implements IReturn<GetProfileOutsideLinksResponse>, IGet
{

    public constructor(init?: Partial<GetProfileOutsideLinks>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileOutsideLinks'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileOutsideLinksResponse(); }
}

// @Route("/profile-settings/outside-links", "POST")
export class UpdateProfileOutsideLinks implements IReturn<ResponseStatus>, IPost
{
    public web: string;
    public fb: string;
    public tw: string;
    public in: string;
    public yt: string;
    public pn: string;
    public tk: string;
    public ln: string;
    public sc: string;

    public constructor(init?: Partial<UpdateProfileOutsideLinks>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileOutsideLinks'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/region")
export class GetProfileRegion implements IReturn<GetProfileRegionResponse>, IGet
{

    public constructor(init?: Partial<GetProfileRegion>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileRegion'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileRegionResponse(); }
}

// @Route("/profile-settings/region")
export class UpdateProfileRegion implements IReturn<ResponseStatus>, IPost
{
    public territoryId: string;

    public constructor(init?: Partial<UpdateProfileRegion>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileRegion'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/representation", "GET")
export class GetProfileRepresentation implements IReturn<GetProfileRepresentationResponse>, IGet
{

    public constructor(init?: Partial<GetProfileRepresentation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileRepresentation'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileRepresentationResponse(); }
}

// @Route("/profile-settings/representation", "POST")
export class UpdateProfileRepresentation implements IReturn<ResponseStatus>, IPost
{
    public representedBy: string;
    public representationLocation: string;
    public representationWebsite: string;
    public unionAffiliations: string[];

    public constructor(init?: Partial<UpdateProfileRepresentation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileRepresentation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/resumes", "GET")
export class GetResumes implements IReturn<GetResumesResponse>, IGet
{

    public constructor(init?: Partial<GetResumes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetResumes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetResumesResponse(); }
}

// @Route("/profile-settings/resumes/upload-pdf", "POST")
export class UploadResume implements IReturn<GetResumesResponse>, IPost
{
    public fileUrl: string;
    public friendlyName: string;

    public constructor(init?: Partial<UploadResume>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UploadResume'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetResumesResponse(); }
}

// @Route("/profile-settings/resumes/update-friendly-name", "POST")
export class UpdateFriendlyNameForUploadedResume implements IReturn<GetResumesResponse>, IPost
{
    public id: string;
    public friendlyName: string;

    public constructor(init?: Partial<UpdateFriendlyNameForUploadedResume>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateFriendlyNameForUploadedResume'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetResumesResponse(); }
}

// @Route("/profile-settings/resumes", "DELETE")
export class DeleteResume implements IReturn<GetResumesResponse>, IDelete
{
    public id: string;

    public constructor(init?: Partial<DeleteResume>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteResume'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GetResumesResponse(); }
}

// @Route("/profile/experiences", "POST")
export class AddExperience implements IReturn<GetExperiencesResponse>, IPost
{
    public type: string;
    public dateYear?: number;
    public showId: string;
    public showName: string;
    public role: string;
    public director: string;
    public companyId: string;
    public companyName: string;

    public constructor(init?: Partial<AddExperience>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddExperience'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetExperiencesResponse(); }
}

// @Route("/profile/experiences/sort", "POST")
export class SortExperiences implements IReturn<ResponseStatus>, IPost
{
    public ids: string[];

    public constructor(init?: Partial<SortExperiences>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SortExperiences'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile/experiences", "GET")
export class GetExperiences implements IReturn<GetExperiencesResponse>, IGet
{

    public constructor(init?: Partial<GetExperiences>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetExperiences'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetExperiencesResponse(); }
}

// @Route("/profile/experiences/feature", "POST")
export class ToggleExperienceIsFeatured implements IReturn<ResponseStatus>, IPost
{
    public id: string;
    public isFeatured: boolean;

    public constructor(init?: Partial<ToggleExperienceIsFeatured>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ToggleExperienceIsFeatured'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile/experiences/remove", "POST")
export class DeleteExperience implements IReturn<ResponseStatus>, IPost
{
    public id: string;

    public constructor(init?: Partial<DeleteExperience>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteExperience'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/basics")
export class GetProfileSettingBasics implements IReturn<GetProfileSettingBasicsResponse>, IGet
{

    public constructor(init?: Partial<GetProfileSettingBasics>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileSettingBasics'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileSettingBasicsResponse(); }
}

// @Route("/profile-settings/basics")
export class UpdateProfileSettingBasics implements IReturn<ResponseStatus>, IPost
{
    public profileDisplayName: string;
    public performerRoles: string[];
    public staffRoles: string[];
    public teacherRoles: string[];
    public intro: string;

    public constructor(init?: Partial<UpdateProfileSettingBasics>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileSettingBasics'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/skills")
export class GetProfileSettingSkills implements IReturn<GetProfileSettingSkillsResponse>, IGet
{

    public constructor(init?: Partial<GetProfileSettingSkills>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileSettingSkills'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileSettingSkillsResponse(); }
}

// @Route("/profile-settings/skills")
export class UpdateProfileSkills implements IReturn<ResponseStatus>, IPost
{
    public vocalPart: string;
    public dancingLevel: string;
    public vocalRangeMin: string;
    public vocalRangeMax: string;
    public educationOrTraining: string;
    public specialSkills: string;

    public constructor(init?: Partial<UpdateProfileSkills>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileSkills'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/appearance", "GET")
export class GetProfileAppearance implements IReturn<GetProfileAppearanceResponse>, IGet
{

    public constructor(init?: Partial<GetProfileAppearance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileAppearance'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileAppearanceResponse(); }
}

// @Route("/profile-settings/appearance", "POST")
export class UpdateProfileAppearance implements IReturn<ResponseStatus>, IPost
{
    public gender: string;
    public heightFeet: string;
    public heightInches: string;
    public ageRange: string;
    public eyes: string;
    public hair: string;
    public bodyType: string;
    public ethnicity: Array<string>;

    public constructor(init?: Partial<UpdateProfileAppearance>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileAppearance'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/reels/add", "POST")
export class AddVideoReelRequest implements IReturn<GetVideoReelsResponse>, IPost
{
    public url: string;
    public provider: string;
    public uniqueId: string;
    public thumbnailUrl: string;

    public constructor(init?: Partial<AddVideoReelRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddVideoReelRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetVideoReelsResponse(); }
}

// @Route("/profile-settings/reels/remove", "DELETE")
export class RemoveVideoReelRequest implements IReturn<GetVideoReelsResponse>, IDelete
{
    public videoReelId: string;

    public constructor(init?: Partial<RemoveVideoReelRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RemoveVideoReelRequest'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GetVideoReelsResponse(); }
}

// @Route("/profile-settings/reels/make-primary", "POST")
export class MakeVideoReelPrimaryRequest implements IReturn<GetVideoReelsResponse>, IPost
{
    public videoReelId: string;

    public constructor(init?: Partial<MakeVideoReelPrimaryRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeVideoReelPrimaryRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetVideoReelsResponse(); }
}

// @Route("/profile-settings/reels", "GET")
export class GetVideoReelsRequest implements IReturn<GetVideoReelsResponse>, IGet
{
    public memberId: string;

    public constructor(init?: Partial<GetVideoReelsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetVideoReelsRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetVideoReelsResponse(); }
}

// @Route("/profile-settings/visibility/", "GET")
export class GetProfileVisibility implements IReturn<GetProfileVisibilityResponse>, IGet
{

    public constructor(init?: Partial<GetProfileVisibility>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileVisibility'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileVisibilityResponse(); }
}

// @Route("/profile-settings/visibility/", "POST")
export class UpdateProfileVisibility implements IReturn<ResponseStatus>, IPost
{
    public visibleTo: string;

    public constructor(init?: Partial<UpdateProfileVisibility>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileVisibility'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile/metadata", "GET")
export class GetUserMetadata implements IReturn<UserMetadata>, IGet
{

    public constructor(init?: Partial<GetUserMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UserMetadata(); }
}

// @Route("/opportunities/near-me", "GET")
export class GetOpportunitiesNearMeRequest implements IReturn<GetOpportunitiesNearMeResponse>
{
    public pageSize: number;

    public constructor(init?: Partial<GetOpportunitiesNearMeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOpportunitiesNearMeRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetOpportunitiesNearMeResponse(); }
}

// @Route("/opportunities/recent-for-widget", "GET")
export class GetRecentOpportunitiesForWidgetRequest implements IReturn<GetRecentOpportunitiesForWidgetResponse>
{
    public pageSize: number;

    public constructor(init?: Partial<GetRecentOpportunitiesForWidgetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRecentOpportunitiesForWidgetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRecentOpportunitiesForWidgetResponse(); }
}

// @Route("/opportunities/{id}/make-invisible", "POST")
export class MakeOpportunityInvisible implements IReturn<ResponseStatus>, IPost
{
    public id: string;

    public constructor(init?: Partial<MakeOpportunityInvisible>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeOpportunityInvisible'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opportunities/{id}/make-visible", "POST")
export class MakeOpportunityVisible implements IReturn<ResponseStatus>, IPost
{
    public id: string;

    public constructor(init?: Partial<MakeOpportunityVisible>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MakeOpportunityVisible'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/my-posts/opportunities/auditions-jobs", "GET")
export class GetOpportunitiesPostedByMe implements IReturn<GetOpportunitiesPostedByMeResponse>, IGet
{
    public currentPage: number;

    public constructor(init?: Partial<GetOpportunitiesPostedByMe>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOpportunitiesPostedByMe'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetOpportunitiesPostedByMeResponse(); }
}

// @Route("/my-posts/opportunities/auditions-jobs/{id}", "GET")
export class GetOpportunityPostedByMe implements IReturn<GetOpportunityPostedByMeResponse>, IGet
{
    public id: string;

    public constructor(init?: Partial<GetOpportunityPostedByMe>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOpportunityPostedByMe'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetOpportunityPostedByMeResponse(); }
}

// @Route("/opportunities/{id}", "POST")
export class UpdateOpportunity implements IReturn<ResponseStatus>, IPost
{
    public id: string;

    public title: string;
    public category: string;
    public format: string;
    public description: string;
    public address: string;
    public webUrl: string;
    public email: string;
    public phone: string;
    public image: string;
    public compensation: string;
    public union: string;
    public showId: string;

    public constructor(init?: Partial<UpdateOpportunity>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateOpportunity'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/my-posts/opportunities/auditions-jobs", "DELETE")
export class DeleteOpportunityPostedByMe implements IReturn<ResponseStatus>, IDelete
{
    public id: string;

    public constructor(init?: Partial<DeleteOpportunityPostedByMe>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteOpportunityPostedByMe'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opportunities/post", "POST")
export class PostAnOpportunity implements IReturn<PostAnOpportunityResponse>, IPost
{
    public category: string;
    public title: string;
    public format: string;
    public regionId: string;
    public description: string;
    public companyId: string;
    public companyName: string;
    public webUrl: string;
    public email: string;
    public phone: string;
    public image: string;
    public startDate: string;
    public endDate: string;
    public compensation: string;
    public union: string;
    public showId: string;
    public address: string;

    public isPreview: boolean;

    public constructor(init?: Partial<PostAnOpportunity>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostAnOpportunity'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostAnOpportunityResponse(); }
}

// @Route("/opportunities/search-by-filter", "GET")
export class SearchOpportunitiesByFiltersRequest implements IReturn<SearchOpportunitiesByFiltersResponse>
{
    public categories: string[];
    public territoryId: string;
    public forMonth: string;
    public isRemoteOnly: boolean;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;
    public sort: string;

    public constructor(init?: Partial<SearchOpportunitiesByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchOpportunitiesByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchOpportunitiesByFiltersResponse(); }
}

// @Route("/onboarding/basic-profile-info")
export class GetBasicProfileInfoForOnboarding implements IReturn<GetBasicProfileInfoForOnboardingResponse>, IGet
{

    public constructor(init?: Partial<GetBasicProfileInfoForOnboarding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBasicProfileInfoForOnboarding'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBasicProfileInfoForOnboardingResponse(); }
}

// @Route("/onboarding/basic-profile-info")
export class UpdateBasicProfileInfoForOnboarding implements IReturn<ResponseStatus>, IPost
{
    public displayName: string;
    public gender: string;
    public ageRange: string;
    public vocalPart: string;

    public constructor(init?: Partial<UpdateBasicProfileInfoForOnboarding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateBasicProfileInfoForOnboarding'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/onboarding/goals")
export class GetGoalsForOnboarding implements IReturn<GetGoalsForOnboardingResponse>, IGet
{

    public constructor(init?: Partial<GetGoalsForOnboarding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetGoalsForOnboarding'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetGoalsForOnboardingResponse(); }
}

// @Route("/onboarding/goals")
export class UpdateGoalsForOnboarding implements IReturn<ResponseStatus>, IPost
{
    public performerRoles: string[];
    public staffRoles: string[];
    public teacherRoles: string[];
    public theatreRoles: string[];

    public constructor(init?: Partial<UpdateGoalsForOnboarding>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateGoalsForOnboarding'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opportunities/{id}/publish-drafted", "POST")
export class PublishDraftedOpportunity implements IReturn<PublishDraftedOpportunityResponse>, IPost
{
    public id: string;

    public constructor(init?: Partial<PublishDraftedOpportunity>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PublishDraftedOpportunity'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PublishDraftedOpportunityResponse(); }
}

// @Route("/moderation/flag", "POST")
export class FlagContent implements IReturn<ResponseStatus>, IPost
{
    public url: string;
    public reason: string;
    public details: string;
    public metadata: { [index: string]: string; };

    public constructor(init?: Partial<FlagContent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FlagContent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/talent/{profileUrl}/message", "POST")
export class MessageMeRequest implements IReturn<ResponseStatus>
{
    public profileUrl: string;

    public constructor(init?: Partial<MessageMeRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MessageMeRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/profile-settings/messaging/", "GET")
export class GetProfileMessaging implements IReturn<GetProfileMessagingResponse>, IGet
{

    public constructor(init?: Partial<GetProfileMessaging>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetProfileMessaging'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetProfileMessagingResponse(); }
}

// @Route("/profile-settings/messaging/", "POST")
export class UpdateProfileMessaging implements IReturn<ResponseStatus>, IPost
{
    public enableMessaging: boolean;

    public constructor(init?: Partial<UpdateProfileMessaging>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateProfileMessaging'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/membership/cancel-pro-subscription", "POST")
export class CancelProMembership implements IPost
{

    public constructor(init?: Partial<CancelProMembership>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CancelProMembership'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/membership/cancel-survey", "POST")
export class SubmitCancelProMembershipSurvey implements IPost
{
    public reason: string;
    public comments: string;

    public constructor(init?: Partial<SubmitCancelProMembershipSurvey>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SubmitCancelProMembershipSurvey'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/membership/preview-change-plan", "POST")
export class PreviewChangeMembershipPlan implements IReturn<PreviewChangeMembershipPlanResponse>, IPost
{
    public couponCode: string;
    public plan: string;

    public constructor(init?: Partial<PreviewChangeMembershipPlan>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PreviewChangeMembershipPlan'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PreviewChangeMembershipPlanResponse(); }
}

// @Route("/membership/change-plan", "POST")
export class ChangeMembershipPlan implements IReturn<ResponseStatus>
{
    public couponCode: string;
    public plan: string;

    public constructor(init?: Partial<ChangeMembershipPlan>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ChangeMembershipPlan'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/membership/reactivate-pro", "POST")
export class ReactivateProMembership implements IReturn<GetMembershipSummaryResponse>
{

    public constructor(init?: Partial<ReactivateProMembership>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ReactivateProMembership'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetMembershipSummaryResponse(); }
}

// @Route("/membership/summary/", "GET")
export class GetMembershipSummary implements IReturn<GetMembershipSummaryResponse>
{

    public constructor(init?: Partial<GetMembershipSummary>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMembershipSummary'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMembershipSummaryResponse(); }
}

// @Route("/membership/upgrade-to-pro", "POST")
export class UpgradeToPro implements IReturn<UpgradeToProResponse>, IPost
{
    public plan: string;
    public stripeHosted: boolean;

    public constructor(init?: Partial<UpgradeToPro>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpgradeToPro'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UpgradeToProResponse(); }
}

// @Route("/landing-pages/community", "GET")
export class GetContentForCommunityLandingPageRequest implements IReturn<GetContentForCommunityLandingPageResponse>, IGet
{

    public constructor(init?: Partial<GetContentForCommunityLandingPageRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetContentForCommunityLandingPageRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetContentForCommunityLandingPageResponse(); }
}

// @Route("/home/guides/popular", "POST")
export class GetPopularGuidesRequest implements IReturn<GetPopularGuidesResponse>
{

    public constructor(init?: Partial<GetPopularGuidesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPopularGuidesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetPopularGuidesResponse(); }
}

// @Route("/home/guides/newest", "POST")
export class GetNewestGuidesRequest implements IReturn<GetNewestGuidesResponse>
{

    public constructor(init?: Partial<GetNewestGuidesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNewestGuidesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetNewestGuidesResponse(); }
}

// @Route("/writers/search-by-filter", "GET")
export class SearchWritersByFiltersRequest implements IReturn<SearchWritersByFiltersResponse>
{
    public name: string;
    public genders: string[];
    public jobTitles: string[];
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;
    public sort: string;

    public constructor(init?: Partial<SearchWritersByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchWritersByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchWritersByFiltersResponse(); }
}

// @Route("/songs/search-by-filter", "GET")
export class SearchSongsByFiltersRequest implements IReturn<SearchSongsByFiltersResponse>
{
    public title: string;
    public genders: string[];
    public voiceTypes: string[];
    public categories: string[];
    public styles: string[];
    public ageRanges: string[];
    public withVideo: boolean;
    public hasCutSuggestions: boolean;
    public hasVocalNotes: boolean;
    public hasContext: boolean;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;
    public sort: string;

    public constructor(init?: Partial<SearchSongsByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchSongsByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchSongsByFiltersResponse(); }
}

// @Route("/shows/search-by-filter", "POST")
export class SearchShowsByFiltersRequest implements IReturn<SearchShowsByFiltersResponse>
{
    public title: string;
    public categories: string[];
    public genres: string[];
    public castSizes: string[];
    public idealFors: string[];
    public withVideo: boolean;
    public hasScript: boolean;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;
    public sort: string;

    public constructor(init?: Partial<SearchShowsByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchShowsByFiltersRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SearchShowsByFiltersResponse(); }
}

// @Route("/shows/recent", "POST")
export class GetRecentShowGuidesRequest implements IReturn<GetRecentShowGuidesResponse>
{
    public pageSize: number;

    public constructor(init?: Partial<GetRecentShowGuidesRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRecentShowGuidesRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetRecentShowGuidesResponse(); }
}

// @Route("/scenes/search-by-filter", "GET")
export class SearchScenesByFiltersRequest implements IReturn<SearchScenesByFiltersResponse>
{
    public characterOption?: number;
    public lengths: string[];
    public styles: string[];
    public periods: string[];
    public displaysFullText?: boolean;
    public withVideo: boolean;
    public sort: string;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;

    public constructor(init?: Partial<SearchScenesByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchScenesByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchScenesByFiltersResponse(); }
}

// @Route("/monologues/search-by-filter", "GET")
export class SearchMonologuesByFiltersRequest implements IReturn<SearchMonologuesByFiltersResponse>
{
    public genders: string[];
    public ageRanges: string[];
    public styles: string[];
    public durations: string[];
    public periods: string[];
    public displaysFullText?: boolean;
    public withVideo: boolean;
    public sort: string;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;

    public constructor(init?: Partial<SearchMonologuesByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchMonologuesByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchMonologuesByFiltersResponse(); }
}

// @Route("/characters/search-by-filter", "GET")
export class SearchCharactersByFiltersRequest implements IReturn<SearchCharactersByFiltersResponse>
{
    public name: string;
    public genders: string[];
    public ageRanges: string[];
    public showCategories: string[];
    public vocalParts: string[];
    public dancingLevels: string[];
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;
    public sort: string;

    public constructor(init?: Partial<SearchCharactersByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchCharactersByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchCharactersByFiltersResponse(); }
}

// @Route("/gamification/profile", "GET")
export class GetMyGamificationProfile implements IReturn<GetMyGamificationProfileResponse>, IGet
{

    public constructor(init?: Partial<GetMyGamificationProfile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMyGamificationProfile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMyGamificationProfileResponse(); }
}

// @Route("/gamification/leaderboard", "GET")
export class GetLeaderboardStats implements IReturn<GetLeaderboardStatsResponse>, IGet
{

    public constructor(init?: Partial<GetLeaderboardStats>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLeaderboardStats'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLeaderboardStatsResponse(); }
}

// @Route("/fanning", "POST")
export class Fan implements IReturnVoid
{
    public id: string;

    public constructor(init?: Partial<Fan>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Fan'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/fanning", "DELETE")
export class Unfan implements IReturnVoid
{
    public id: string;

    public constructor(init?: Partial<Unfan>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Unfan'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() {}
}

// @Route("/contact-us")
export class ContactUsRequest
{
    public name: string;
    public subject: string;
    public email: string;
    public message: string;
    public gRecaptchaResponse: string;

    public constructor(init?: Partial<ContactUsRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContactUsRequest'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/college-programs/search-by-filter", "GET")
export class SearchCollegeProgramsByFiltersRequest implements IReturn<SearchCollegeProgramsByFiltersResponse>
{
    public programName: string;
    public majors: string[];
    public degrees: string[];
    public territoryId: string;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;
    public sort: string;

    public constructor(init?: Partial<SearchCollegeProgramsByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchCollegeProgramsByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchCollegeProgramsByFiltersResponse(); }
}

// @Route("/bookmarks", "GET")
export class GetBookmarks implements IReturn<GetBookmarksResponse>
{

    public constructor(init?: Partial<GetBookmarks>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBookmarks'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBookmarksResponse(); }
}

// @Route("/bookmarks", "POST")
export class AddBookmark implements IReturn<AddBookmarkResponse>
{
    public id: string;

    public constructor(init?: Partial<AddBookmark>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddBookmark'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AddBookmarkResponse(); }
}

// @Route("/bookmarks", "DELETE")
export class DeleteBookmark implements IReturn<DeleteBookmarkResponse>
{
    public id: string;

    public constructor(init?: Partial<DeleteBookmark>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteBookmark'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DeleteBookmarkResponse(); }
}

// @Route("/blogs/recent-for-widget", "GET")
export class GetRecentPostsForWidgetRequest implements IReturn<GetRecentPostsForWidgetResponse>
{
    public pageSize: number;

    public constructor(init?: Partial<GetRecentPostsForWidgetRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRecentPostsForWidgetRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRecentPostsForWidgetResponse(); }
}

// @Route("/signin", "POST")
export class SignIn implements IReturn<SignInResponse>
{
    public email: string;
    public password: string;
    public redirectUrl: string;
    public rememberMe: boolean;

    public constructor(init?: Partial<SignIn>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SignIn'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SignInResponse(); }
}

// @Route("/auth/unlink-auth")
export class UnlinkAuthProvider implements IReturn<ResponseStatus>
{
    public provider: string;

    public constructor(init?: Partial<UnlinkAuthProvider>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnlinkAuthProvider'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/forgot-password", "POST")
export class ForgotPassword implements IReturn<ForgotPasswordResponse>, IPost
{
    public email: string;

    public constructor(init?: Partial<ForgotPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ForgotPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ForgotPasswordResponse(); }
}

// @Route("/reset-password", "POST")
export class ResetPassword implements IReturn<ResetPasswordResponse>, IPost
{
    public token: string;
    public password: string;
    public repeatPassword: string;

    public constructor(init?: Partial<ResetPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ResetPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResetPasswordResponse(); }
}

// @Route("/theatre-auditions/search-by-filter", "GET")
export class SearchTheatreAuditionsByFiltersRequest implements IReturn<SearchTheatreAuditionsByFiltersResponse>
{
    public territoryId: string;
    public sort: string;
    public currentPage: number;
    public defaultPage: number;
    public pageSize: number;

    public constructor(init?: Partial<SearchTheatreAuditionsByFiltersRequest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SearchTheatreAuditionsByFiltersRequest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SearchTheatreAuditionsByFiltersResponse(); }
}

// @Route("/account-settings/email-notifications/")
export class GetAccountEmailNotificationsSettings implements IReturn<GetAccountEmailNotificationsSettingsResponse>
{

    public constructor(init?: Partial<GetAccountEmailNotificationsSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccountEmailNotificationsSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAccountEmailNotificationsSettingsResponse(); }
}

// @Route("/account-settings/email-notifications/", "POST")
export class UpdateAccountEmailNotificationsSettings implements IReturn<ResponseStatus>
{
    public emailNotifications: string[];
    public opportunityEmailDigestPreference: string;

    public constructor(init?: Partial<UpdateAccountEmailNotificationsSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateAccountEmailNotificationsSettings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/account-settings/manager")
export class GetAccountManagerSettings implements IReturn<GetAccountManagerSettingsResponse>, IGet
{

    public constructor(init?: Partial<GetAccountManagerSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccountManagerSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAccountManagerSettingsResponse(); }
}

// @Route("/account-settings/manager", "POST")
export class UpdateAccountManagerSettings implements IReturn<ResponseStatus>
{
    public firstName: string;
    public lastName: string;

    public constructor(init?: Partial<UpdateAccountManagerSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UpdateAccountManagerSettings'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/account-settings/subscription-preferences/")
export class GetSubscriptionPreferences implements IReturn<GetSubscriptionPreferencesResponse>, IGet
{

    public constructor(init?: Partial<GetSubscriptionPreferences>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSubscriptionPreferences'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSubscriptionPreferencesResponse(); }
}

/** @description Sign In */
// @Route("/auth", "OPTIONS,GET,POST,DELETE")
// @Route("/auth/{provider}", "OPTIONS,GET,POST,DELETE")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public state: string;

    // @DataMember(Order=3)
    public oauth_token: string;

    // @DataMember(Order=4)
    public oauth_verifier: string;

    // @DataMember(Order=5)
    public userName: string;

    // @DataMember(Order=6)
    public password: string;

    // @DataMember(Order=7)
    public rememberMe?: boolean;

    // @DataMember(Order=9)
    public errorView: string;

    // @DataMember(Order=10)
    public nonce: string;

    // @DataMember(Order=11)
    public uri: string;

    // @DataMember(Order=12)
    public response: string;

    // @DataMember(Order=13)
    public qop: string;

    // @DataMember(Order=14)
    public nc: string;

    // @DataMember(Order=15)
    public cnonce: string;

    // @DataMember(Order=17)
    public accessToken: string;

    // @DataMember(Order=18)
    public accessTokenSecret: string;

    // @DataMember(Order=19)
    public scope: string;

    // @DataMember(Order=20)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

